module.exports = __webpack_public_path__ + "img/shadow_ios_en.ca0f138.png";